import { FC, PropsWithChildren } from 'react';

import { Box } from '@sparky';
import { styled } from '@sparky/stitches';

export const AnimatedBox = styled(Box, {
  overflow: 'hidden',
  margin: '-10px',
  padding: '10px',
  transition: 'height 0.5s',
});

interface AnimateheightboxProps extends PropsWithChildren {
  newHeight?: number;
  isAnimating?: boolean;
}

export const AnimateHeightBox: FC<AnimateheightboxProps> = ({ children, newHeight, isAnimating }) => (
  <AnimatedBox css={isAnimating ? { height: newHeight } : { height: 'auto' }}>{children}</AnimatedBox>
);
